var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKitchenManual(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 21,
    viewBox: "0 0 17 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#001c33",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 20,
    strokeWidth: 1.5,
    d: "M1.27 17.661a2.341 2.341 0 012.341-2.341h12.643v0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#001c33",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 20,
    strokeWidth: 1.5,
    d: "M3.611 1.27h12.643V20H3.611a2.341 2.341 0 01-2.341-2.34V3.61a2.341 2.341 0 012.341-2.34z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNyIgaGVpZ2h0PSIyMSIgdmlld0JveD0iMCAwIDE3IDIxIj48Zz48Zz48Zz48Zz48cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiMwMDFjMzMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjIwIiBzdHJva2Utd2lkdGg9IjEuNSIgZD0iTTEuMjcgMTcuNjYxYTIuMzQxIDIuMzQxIDAgMCAxIDIuMzQxLTIuMzQxaDEyLjY0M3YwIi8+PC9nPjxnPjxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMWMzMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2UtbWl0ZXJsaW1pdD0iMjAiIHN0cm9rZS13aWR0aD0iMS41IiBkPSJNMy42MTEgMS4yN2gxMi42NDNWMjBIMy42MTFBMi4zNDEgMi4zNDEgMCAwIDEgMS4yNyAxNy42NlYzLjYxQTIuMzQxIDIuMzQxIDAgMCAxIDMuNjExIDEuMjd6Ii8+PC9nPjwvZz48L2c+PC9nPjwvc3ZnPg==";
export { SvgKitchenManual as ReactComponent };